export default "__VITE_ASSET__DT$FbGhq__"